export default {
  headerContent: {
    title: 'Atlas Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Atlas Mutuel Sigorta Nakliyat (Emtea) Sigortası',
    description: {
      title: 'Atlas Sigorta Nakliyat (Emtea) Sigortası Nedir? ',
      content: [
        'Nakliyat sigortası, bir emteanın karayolu, deniz yolu veya hava yolu ile bir yerden başka bir yere taşınması esnasında karşılaşabileceği risklere karşı güvence sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Atlas Sigorta Nakliyat Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: 'Nakliyat sigortasında 3 adet teminat bulunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu teminatlar;',
          subList: ['Tam Ziya teminatı,', 'Dar Teminat,', 'Geniş Teminatı.']
        },
        {
          paragraph: 'Tam Ziya Teminatı Nedir?',
          subList: null
        },
        {
          paragraph:
            'Taşıma aracı ve malın tüm değerini kaybedecek derece hasar görmesini halinde karşılık verilen teminattır.',
          subList: null
        },
        {
          paragraph: 'Dar Teminat Nedir?',
          subList: null
        },
        {
          paragraph:
            'Dar teminat malın ve taşıma aracının uğrayacağı kısmı hasarlar sonucu çıkan masrafları teminat altına almaktadır. Dar teminat kapsamında 2 adet kloz bulunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu klozlar;',
          subList: null
        },
        {
          paragraph: 'Denizyolu klozu;',
          subList: null
        },
        {
          paragraph:
            'Aşağıda belirtilmiş olan risklerin deniz yolunda meydana gelmesi sonucunda teminat verilmektedir.',
          subList: [
            'Yangın, infilak,',
            'Geminin karaya oturması, batması, yanması, sudan başka bir cisimle çatışması,',
            'Müşterek avarya fedakarlığı ve müşterek avarya katılma payı',
            'Kurtarma ve yardım masrafları',
            'Dava say masrafları',
            'Yükleme ve boşaltma sırasında bir veya birden çok kolinin tam zıyaa uğraması'
          ]
        },
        {
          paragraph: 'Karayolu klozu;',
          subList: null
        },
        {
          paragraph:
            'Aşağıda belirtilmiş olan risklerin karayolunda oluşması durumunda teminat sağlanmaktadır..',
          subList: [
            'Nakil vasıtasının yanması,',
            'Çarpması,',
            'Çarpışması,',
            'Ateş,',
            'Yıldırım,',
            'Seylap,',
            'Köprü yıkılması,',
            'Kamyon veya treylerin devrilmesi,',
            'Trenin raydan çıkması'
          ]
        },
        {
          paragraph: 'Geniş Teminat Nedir?',
          subList: null
        },
        {
          paragraph:
            'Geniş teminat ile taşınan malda taşıma esnasında oluşacak kaza veya olay neticesindeki maddi kayıplara karşı güvence sağlamaktadır.',
          subList: [
            'Nakliyat esnasında gecikmeden kaynaklanan hasar ve masraflar',
            'Fire, çürüme, bozulma gibi malın kendi bünyesinden kaynaklanan hasarlar',
            'Malın kendi kusuru, üretiminden kaynaklanan hasarlar (ayb-ı zati )',
            'Ambalaj yetersizliği',
            'Sigortalının veya adamlarının kasdi kötü niyetli hareketlerinden kaynaklanan hasar ve masraflar',
            'Radyoaktif kirlenme',
            'Harp ve grev rizikoları',
            'Normal akma ve eksilme, eskime ve aşınma , yıpranma.',
            'Donatanın iflası ve mali kusuru.',
            'Atomik ve nükleer harp.',
            'Sigortalı tarafından bilinen denize ve yüke elverişsizlik.',
            'Harp, isyan, glkknh, terörizm',
            'Fare, kurt vb. Haşaratın ika ettiği tahribat.',
            'Yasak ve gizli ticaret, kaçakçılık',
            'Hakikat dışı beyan, kanuna aykırılık',
            'Karantina ve kışlama tevakkufları',
            'Faiz kayıpları, kur ve rayiç farkları teminat dahilindedir.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Nakliyat Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Nakliyat Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Atlas Mutuel Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Atlas Sigorta Nakliyat Poliçesi Düzenlenirken Talep Edilen Bilgiler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Emtea Bedeli.',
            'Emtea Türü.',
            'Firma ise vergi kimlik numarası, şahıs ise TC numarası.',
            'Sevk başlangıç ve bitiş noktası.',
            'Sevk Başlangıç ve bitiş tarihleri.',
            'Sevki gerçekleştirecek araç bilgileri.'
          ]
        }
      ]
    },
    {
      title:
        'Atlas Sigorta Nakliyat Poliçesi Hasar Anında Talep Edilen Belge/Bilgiler Nelerdir?',
      content: [
        {
          paragraph:
            'Hasar anında istenen bilgi ve belgeler hasar boyutuna göre değişmektedir.',
          subList: null
        },
        {
          paragraph: 'Genel olarak aşağıdaki bilgi ve belgeler istenmektedir.',
          subList: [
            'Poliçe numarası',
            'Hasar tarihi',
            'Tahmini hasar miktarı',
            'Sigortalının veya irtibat kurulacak kişinin iletişim bilgisi'
          ]
        }
      ]
    },
    {
      title: 'Atlas Sigorta Sigorta’dan Neden Nakliyat Sigortası Almalıyım?',
      content: [
        {
          paragraph:
            'Atlas Sigorta sigortanın sağlamış olduğu avantaj ile emteanızı ve aracınızı koruma altına alarak malın nakliyesi esnasında risklerin oluşması sonucunda meydana çıkan büyük çaplı finansal maliyetleri güvence altına alabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Nakliyat Sigortası Yaptırmak Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası düzenlenmesi için yasal bir zorunluluk bulunmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Nakliyat Sigortası Kim Tarafından Yaptırılır?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası, nakliyeyi yüklenen firma veya gönderici kişi veya kurum tarafından yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Nakliyat Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Nakliyet sigortası fiyatları, seçilmiş olan teminatlara ve kloza göre farklılık göstermektedir. Bu nedenle net bir nakliyat sigortası fiyatı bulunmamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Atlas Sigorta nakliyat sigortası fiyatlarını değerlendirmek için başvuru formu doldura bilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Atlas Sigorta Nakliyat Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Atlas Sigorta nakliyat sigortası tekliflerini alokasko.com güvencesi ile alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com ayrıcalığıyla poliçe satın almak için 3 farklı seçenek bulunmaktadır. Nakliyat sigortanızı online teklif ekranımızdan, çağrı merkezimizden veya ofisimizi ziyaret ederek alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Online nakliyat sigortası tekliflerini değerlendirmek için alokasko.com üzerinde yer alan nakliyat sigortası başvuru formunu doldura bilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
